/** Transporta solo los integrantes y la revisión que el usuario editó. */
export const materialGroupPayload = (form) => ({
  code: form.code.trim(),
  name: form.name.trim(),
  article_ids: form.articles.map((article) => article.uuid),
  expected_revision: form.revision || null,
});
